import { relocationGetProductsByLocationValidate } from "../../application/dtos/relocation_get_products_by_location_validate";

export class relocationProductsEntity {
    constructor({ data }){
        this.data = data;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return relocationGetProductsByLocationValidate(this);
    }
}